import client from './client'

async function choose ({ desk }) {
  const response = await client.post(`desk-session`, {
    desk
  })
  if (response.status === 200) {
    return {
      status: 'OK'
    }
  }
  return null
}

async function leave () {
  await client.delete('/desk-session')
}

export default {
  choose,
  leave
}
